import { useIntl } from "react-intl";

type ZipcodeLookupSpinnerProps = {
  visible: boolean;
};

function ZipcodeLookupSpinner({ visible }: ZipcodeLookupSpinnerProps) {
  const intl = useIntl();

  if (!visible) {
    return null;
  }

  return (
    <div
      className="spinner-border spinner-border-sm text-primary ml-2 flex-shrink-0"
      role="status"
      aria-live="polite"
      aria-label={intl.formatMessage({
        id: "settings.address-book.zipcodeLookupLoading",
        defaultMessage: "Looking up city and state",
      })}
    />
  );
}

export default ZipcodeLookupSpinner;
